export type MenuOption = {
  value: string;
  label: string | JSX.Element;
};

export const NONE = "none";
export const ALL = "all";
